export function requestNotificationPermission() {
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission();
  }
}

export function showBrowserNotification(data) {
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification('Nueva Notificación IEL', {
      body: 'Se ha agregado una nueva actualización IEL',
      icon: '/favicon.ico',
      tag: `notification-${data.notification_id}`,
      requireInteraction: false,
      silent: false,
    });
  }
}
